import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { Triangle2View } from './careers-intro-triangle2.view';

export const Triangle2 = () => {
  const { stripes } = useStaticQuery(graphql`
    query {
      stripes: file(relativePath: { eq: "pages/careers/intro/careers-intro-triangle2.svg" }) {
        publicURL
      }
    }
  `);

  return <Triangle2View imageSrc={stripes.publicURL} />;
};
